<template>
  <div class="fixed inset-0 z-50 grid place-items-center bg-slate-950/55 px-4 py-6" role="dialog" aria-modal="true" aria-label="Report flyer" @click.self="$emit('close')">
    <form class="w-full max-w-sm overflow-hidden rounded-2xl bg-white shadow-2xl" @submit.prevent="submitReport">
      <header class="flex items-center justify-between border-b border-slate-200 px-4 py-3">
        <div>
          <h2 class="m-0 text-lg font-black text-slate-950">Report flyer</h2>
          <p class="m-0 mt-1 text-xs font-bold text-slate-500">{{ flyer.category || 'NetFlyr' }}</p>
        </div>
        <button class="grid h-9 w-9 place-items-center rounded-full text-slate-500 hover:bg-slate-100 hover:text-slate-950" type="button" aria-label="Close report modal" @click="$emit('close')">
          <i class="ri-close-line text-xl" aria-hidden="true"></i>
        </button>
      </header>

      <div class="grid gap-4 p-4">
        <label class="grid gap-2 text-sm font-black text-slate-700">
          <span>Reason</span>
          <select v-model="reason" class="min-h-11 rounded-xl border border-slate-300 bg-white px-3 text-sm font-bold text-slate-900 outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100">
            <option value="Spam">Spam</option>
            <option value="Incorrect information">Incorrect information</option>
            <option value="Offensive content">Offensive content</option>
            <option value="Other">Other</option>
          </select>
        </label>

        <label class="grid gap-2 text-sm font-black text-slate-700">
          <span>Details</span>
          <textarea v-model="details" class="min-h-24 rounded-xl border border-slate-300 px-3 py-2 text-sm font-semibold text-slate-900 outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100" placeholder="Add details..." />
        </label>

        <div class="grid grid-cols-2 gap-3">
          <button class="min-h-11 rounded-xl border border-slate-200 bg-white text-sm font-black text-slate-700 hover:bg-slate-50" type="button" @click="$emit('close')">Cancel</button>
          <button class="nf-primary-button" type="submit">Submit</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
  flyer: { type: Object, required: true }
})

const emit = defineEmits(['close', 'submit'])
const reason = ref('Spam')
const details = ref('')

const submitReport = () => {
  emit('submit', {
    reason: reason.value,
    details: details.value.trim()
  })
  emit('close')
}
</script>
